import { createContext, useState } from "react";

export const CategoriesContext = createContext();

export const CategoriesContextProvider = ({ children }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);

    const contextValue = {
        selectedCategories,
        setSelectedCategories
    };

    return (
        <CategoriesContext.Provider value={ contextValue }>
            { children }
        </CategoriesContext.Provider>
    );
}
